import { render, staticRenderFns } from "./ProductBlockComponent.vue?vue&type=template&id=6dd82088"
import script from "./ProductBlockComponent.vue?vue&type=script&lang=js"
export * from "./ProductBlockComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports